import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, setPropTypes, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import CommonButtonId from '../../components/atoms/CommonButtonId';

const styles = {
  root: {
    marginTop: 15
  },
  overflow: {
    overflow: 'auto'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  },
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      tickets: state.tickets.list,
      totalCount: state.tickets.count
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    tickets,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    setRowsPerPage,
    onChangeTicketStatus,
    progress
  }) => {
    function onClickChangeStatus(id, lalapayFlag) {
      if (lalapayFlag === 1) {
        progress.setErrorMessage(
          'LalaPay チャージ履歴のため、未使用ができません。'
        );
      } else {
        onChangeTicketStatus([id]);
      }
    }

    return (
      <div className={classes.root}>
        <div className={classes.scrollTable}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>shashoku_ticket_id</TableCell>
                <TableCell>user_ticket_id</TableCell>
                <TableCell>user_name</TableCell>
                <TableCell>Shop_id</TableCell>
                <TableCell>shop_name</TableCell>
                <TableCell>menu_id</TableCell>
                <TableCell>Menu_name</TableCell>
                <TableCell>User_email</TableCell>
                <TableCell>Used_price</TableCell>
                <TableCell>Used_time</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {tickets &&
                tickets.map(ticket => (
                  <TableRow>
                    <TableCell>{ticket.shashokuTicketId}</TableCell>
                    <TableCell>{ticket.userTicketId}</TableCell>
                    <TableCell>{ticket.displayName}</TableCell>
                    <TableCell>{ticket.shopId}</TableCell>
                    <TableCell>{ticket.shopName}</TableCell>
                    <TableCell>{ticket.menuId}</TableCell>
                    <TableCell>{ticket.menuName}</TableCell>
                    <TableCell>{ticket.userEmail}</TableCell>
                    <TableCell>{ticket.usedPrice}</TableCell>
                    <TableCell>{ticket.createdAt}</TableCell>
                    <TableCell>
                      <CommonButtonId
                        className={classes.button}
                        title="個別で未使用にする"
                        onClickAction={() =>
                          onClickChangeStatus(
                            ticket.shashokuTicketId,
                            ticket.lalapayFlag
                          )
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>

        <ExPaginationGroup
          count={
            totalCount % rowsPerPage > 0
              ? Math.floor(totalCount / rowsPerPage) + 1
              : Math.floor(totalCount / rowsPerPage)
          }
          selectedPage={page}
          handleChangePage={(e, p, limit) => handleChangePage(e, p, limit)}
          limit={rowsPerPage}
          totalCount={totalCount}
          setLimit={setRowsPerPage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
